import { Navigation } from './Navigation';
import { SearchBar } from './SearchBar';
import { FormattedMessage } from 'react-intl';

export function Hero() {
  return (
    <header className='bg-gradient-to-r from-blue-600 to-blue-700 text-white'>
      <Navigation />
      <div className='container mx-auto px-6 py-12 md:py-20'>
        <div className='max-w-3xl'>
          <h1 className='text-3xl md:text-5xl font-bold mb-6'>
            <FormattedMessage
              id='hero.title'
              defaultMessage='Найдите надёжных специалистов в вашем городе'
            />
          </h1>
          <p className='text-xl mb-8 text-blue-100'>
            <FormattedMessage
              id='hero.description'
              defaultMessage='Ваша платформа для поиска качественных услуг в Румынии'
            />
          </p>
          <SearchBar />
        </div>
      </div>
    </header>
  );
}
